import { render } from "./WelcomeView.vue?vue&type=template&id=5d5ec290"
import script from "./WelcomeView.vue?vue&type=script&lang=js"
export * from "./WelcomeView.vue?vue&type=script&lang=js"

import "./WelcomeView.vue?vue&type=style&index=0&id=5d5ec290&lang=css"

import exportComponent from "/Users/cookiemonster/Isaac_Files/Projects_Software/personal-page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__